import React from 'react';

import { gql } from '@apollo/client';
import { FCWithFragments } from '@modernloop/shared/components';
import { Stack } from '@mui/material';

import { DebriefContentDetails_DebriefFragment } from 'src/generated/mloop-graphql';

import AdditionalAttendeesDetails from 'src/entities/common/AdditionalAttendeesDetails';

import DebriefContentDetailsInterviewer from './DebriefContentDetailsInterviewer';
import DebriefContentDetailsMeetingRoom from './DebriefContentDetailsMeetingRoom';

type Fragments = {
  debrief: DebriefContentDetails_DebriefFragment;
};

type Props = {
  timezone: string;
};

const DebriefContentDetails: FCWithFragments<Fragments, Props> = ({ debrief, timezone }) => {
  return (
    <Stack spacing={2} sx={{ pl: 2.5, pr: 1.5, py: 1 }}>
      {debrief.attendees?.map((interviewer) => (
        <DebriefContentDetailsInterviewer
          key={`${interviewer.interviewerId}-${interviewer.interviewerId}`}
          attendee={interviewer}
          timezone={timezone}
        />
      ))}

      {debrief.meetingRooms?.map((room) => (
        <DebriefContentDetailsMeetingRoom key={room.applicationDebriefId} meetingRoom={room} />
      ))}

      <AdditionalAttendeesDetails additionalAttendees={debrief.additionalAttendeesV2} />
    </Stack>
  );
};

DebriefContentDetails.fragments = {
  debrief: gql`
    ${DebriefContentDetailsInterviewer.fragments.attendee}
    ${DebriefContentDetailsMeetingRoom.fragments.meetingRoom}
    ${AdditionalAttendeesDetails.fragments.additionalAttendees}
    fragment DebriefContentDetails_debrief on ApplicationDebrief {
      id
      additionalAttendeesV2 {
        ...AdditionalAttendeesDetails_additionalAttendees
      }
      attendees {
        applicationDebriefId
        ...DebriefContentDetailsInterviewer_debrief
      }
      meetingRooms {
        applicationDebriefId
        meetingRoomId
        ...DebriefContentDetailsMeetingRoom_meetingRoom
      }
    }
  `,
};

export default DebriefContentDetails;
